import { FC } from 'react';
import { ISvgIcon } from 'types';

const MenuAdminManagementSvg: FC<ISvgIcon> = ({
  width = '24',
  height = '24',
  fill = 'white',
  fillOpacity = 0.6,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64496 4.4718C9.64496 3.17098 10.6995 2.11646 12.0003 2.11646C13.3011 2.11646 14.3557 3.17098 14.3557 4.4718C14.3557 5.77263 13.3011 6.82715 12.0003 6.82715C10.6995 6.82715 9.64496 5.77263 9.64496 4.4718Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M12.9424 7.51667H11.0582C9.49718 7.51667 8.23175 8.7821 8.23175 10.3431V10.5786C8.23175 10.9689 8.54811 11.2852 8.93835 11.2852H15.0623C15.4525 11.2852 15.7689 10.9689 15.7689 10.5786V10.3431C15.7689 8.7821 14.5034 7.51667 12.9424 7.51667Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M3.12561 15.4745C3.12561 14.1737 4.18014 13.1192 5.48096 13.1192C6.78178 13.1192 7.83631 14.1737 7.83631 15.4745C7.83631 16.7753 6.78178 17.8299 5.48096 17.8299C4.18014 17.8299 3.12561 16.7753 3.12561 15.4745Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M6.4231 18.5194H4.53882C2.97783 18.5194 1.7124 19.7848 1.7124 21.3458V21.5813C1.7124 21.9716 2.02876 22.2879 2.41901 22.2879H8.54291C8.93316 22.2879 9.24952 21.9716 9.24952 21.5813V21.3458C9.24952 19.7848 7.98409 18.5194 6.4231 18.5194Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M16.1642 15.4745C16.1642 14.1737 17.2187 13.1192 18.5195 13.1192C19.8203 13.1192 20.8749 14.1737 20.8749 15.4745C20.8749 16.7753 19.8203 17.8299 18.5195 17.8299C17.2187 17.8299 16.1642 16.7753 16.1642 15.4745Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M19.4617 18.5194H17.5774C16.0164 18.5194 14.751 19.7848 14.751 21.3458V21.5813C14.751 21.9716 15.0673 22.2879 15.4576 22.2879H21.5815C21.9717 22.2879 22.2881 21.9716 22.2881 21.5813V21.3458C22.2881 19.7848 21.0227 18.5194 19.4617 18.5194Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
      <path
        d="M14.2919 17.9427C14.4267 17.9427 14.5596 17.8836 14.6505 17.7708C14.8086 17.5729 14.7763 17.2846 14.5789 17.1261L12.4586 15.4299V12.8999C12.4586 12.6465 12.2536 12.4414 12.0002 12.4414C11.7467 12.4414 11.5417 12.6464 11.5417 12.8998V15.4302L9.42142 17.1261C9.22398 17.2846 9.19174 17.5729 9.34978 17.7708C9.44068 17.8836 9.57361 17.9427 9.70839 17.9427C9.80866 17.9427 9.90988 17.91 9.99446 17.8424L12.0002 16.2379L14.0058 17.8424C14.0904 17.91 14.1916 17.9427 14.2919 17.9427Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default MenuAdminManagementSvg;
